module.exports = __webpack_public_path__ + "static/media/desert4.e0231e74.png";